var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { HelpPopOver } from '@appspotr/ui-kit';
import { Wrapper } from '../../SbGlobal/styles';
import { Container, HelperWrapper, Text } from './styles';
export var BlockWidget = function (_a) {
    var label = _a.label, youTubeId = _a.youTubeId, title = _a.title, info = _a.info, link = _a.link, onClick = _a.onClick, helpModalOpen = _a.helpModalOpen;
    var _b = useState(false), isVisible = _b[0], setIsVisible = _b[1];
    return (_jsxs(Container, { children: [_jsx(Wrapper, { children: _jsx(Text, __assign({ onClick: onClick }, { children: label })) }), (youTubeId || link) && (_jsx(HelperWrapper, __assign({ isOpen: isVisible }, { children: _jsx(HelpPopOver, { youTubeId: youTubeId || 'YoutubeVideoNotFound', title: title || 'Title', info: _jsx(_Fragment, { children: info }), type: 'structure', link: link, helpModalOpen: helpModalOpen, isVisible: isVisible, setIsVisible: setIsVisible }) })))] }));
};
